<template>
    <div ref="wrapper" class="position-relative">
        <input type="search" :value="props.search" :class="props.inputClass" class="form-control" placeholder="Ort eingeben..." @click="dropdown(true)" @focus="dropdown(true)" @input="input($event.target.value)" />
        <div v-if="state.showLocations" id="persons-popover" class="position-absolute top-100 start-0 shadow rounded bg-white p-3" style="min-width: 400px;">
            <ul class="list-unstyled mb-0">
                <li v-if="searchEmpty" class="p-2 text-info">Keine Ergebnisse gefunden</li>
                <li v-for="(travels, country) in filteredLocations" :key="'locations-country-' + country" class="p-2">
                    <span class="country text-primary text-uppercase small">{{ country }}</span>
                    <ul class="list-unstyled mb-0">
                        <li v-for="travel in travels" :key="'locations-' + travel.id" class="destination py-1" :class="{ active: isSelected(travel.destination) }" @click="select(travel)" role="button">
                            {{ travel.destination }}
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
    </div>
</template>
<script setup>
import { ref, reactive, computed, watch } from 'vue';
import { onClickOutside } from '@vueuse/core'

const emit = defineEmits(['update:search', 'update:code']);
const wrapper = ref(null);

const props = defineProps({
    locations: Object,
    search: String,
    code: Number,
    inputClass: String,
});

const state = reactive({
    showLocations: false,
});

function dropdown(visible) {
    state.showLocations = visible;
}

function input(value) {
    emit('update:code', null);
    emit('update:search', value);
}

function select(travel) {
    console.log(travel.code);
    emit('update:search', travel.destination);
    emit('update:code', travel.code);
    dropdown(false);
}

function isSelected(title) {
    return props.search == title;
}

const filteredLocations = computed(() => {

    // Clone object
    const locations = Object.assign({}, props.locations);

    // Empty search
    if (!props.search || !props.search.length) {
        return locations;
    }

    let filtered = locations;

    let destinations;

    Object.keys(filtered).forEach((country) => {

        const items = filtered[country];
        // console.log(items);

        destinations = items.filter((travel) => {
            if (travel.destination.toLowerCase().search(props.search.toLowerCase()) > -1) {
                return true;
            }
            return false;
        });
        // console.log(destinations);

        if (!destinations.length) {
            delete filtered[country];
        } else {
            filtered[country] = destinations;
        }
    });

    // console.log(filtered);
    return filtered;
});

const searchEmpty = computed(() => {
    return props.search && _.isEmpty(filteredLocations.value)
})

onClickOutside(wrapper, (event) => dropdown(false))
</script>
